'use client';

import { useEffect } from 'react';
import { trackEvent } from '../../../../../lib/analytics/posthog';
import { EVENTS } from '../../../../../lib/analytics/events';

export default function ServiceDetailTracker({ vendor, service }) {
  useEffect(() => {
    trackEvent(EVENTS.VENDOR_SERVICE_DETAIL_VIEWED, {
      vendor_username: vendor.username,
      vendor_category: vendor.services?.[0]?.category_sub_category?.category?.name,
      service_name: service.name,
      service_slug: service.slug,
      has_price: !!service.price,
      has_duration: !!service.duration,
      price: service.price || null,
      duration: service.duration || null
    });
    // Una vista por página montada: si las props cambian (un objeto nuevo en un refresh del RSC), no
    // es otra vista. Cambiar de página remonta el componente.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
